export default "__VITE_ASSET__BpA1LbQT__"